module.exports = __webpack_public_path__ + "img/DiscordIcon.bc6500a4.svg";